module.exports = __webpack_public_path__ + "img/yl3012.58bd94ba.png";